import { useRef, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './homepage-carrousel.css'
export default function HomepageCarrousel({ articles = [] }) {

  const swiperRef = useRef(null);
  const navigate = useNavigate();
  if (!articles.length) {
    return null
  }
  const handleHtmlClick = (e) => {
    const link = e.target.closest("a");
    if (!link) return;
    const href = link.getAttribute("href");
    if (!href || !href.startsWith("/")) return;
    e.preventDefault();
    navigate(href);
  };

  ;
  return (
    <section className="homepage-carrousel-group v2">
      <div className="articles-group-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          loop
          speed={800}
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation
          onSwiper={(swiper) => {
            swiperRef.current = swiper
            setTimeout(() => {
              swiper.slides.forEach(s => s.classList.remove('on-stage'))
              swiper.slides[swiper.activeIndex]?.classList.add('on-stage')
            }, 750)
          }}
          onSlideChangeTransitionStart={(swiper) => {
            swiper.slides.forEach(s => s.classList.remove('on-stage'))
          }}
          onSlideChangeTransitionEnd={(swiper) => {

            swiper.slides[swiper.activeIndex]?.classList.add('on-stage')
          }}
        >
          {articles.map((article, index) => (
            <SwiperSlide key={index}>
              <article className="homepage-carrousel">
                <div className="article-inner">
                  <div className="d-flex content-row">

                    <div className="wordings">
                      <div className="bg" />
                      <div className="wordings-inner">
                        <div className="title">
                          {article.title}
                        </div>
                        <div
                          className="text"
                          onClick={handleHtmlClick}
                          dangerouslySetInnerHTML={{ __html: article.text }}
                        />
                      </div>
                    </div>

                    <div className="attachment">
                      {article.image && (
                        <img
                          src={article.image}
                          alt={article.title}
                          loading="lazy"
                        />
                      )}
                    </div>

                  </div>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}
